import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SuperAdminLogin from './SuperAdminLogin';
import SuperAdminDashboard from './SuperAdminDashboard';

export default function SuperAdminApp() {
  return (
    <Routes>
      <Route path="/login" element={<SuperAdminLogin />} />
      <Route path="/dashboard" element={<SuperAdminDashboard />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
